(function () {
  const POPUP_ID = 'ceHolidayPopup';
  const STORAGE_KEY = 'ceHolidayPopupSeen';

  if (sessionStorage.getItem(STORAGE_KEY)) return;

  document.addEventListener('DOMContentLoaded', function () {
    const popup = document.getElementById(POPUP_ID);
    if (!popup) return;

    const closeButtons = popup.querySelectorAll('[data-ce-popup-close]');

    function openPopup() {
      popup.classList.add('is-visible');
      popup.setAttribute('aria-hidden', 'false');
      sessionStorage.setItem(STORAGE_KEY, 'true');
    }

    function closePopup() {
      popup.classList.remove('is-visible');
      popup.setAttribute('aria-hidden', 'true');
    }

    closeButtons.forEach(btn =>
      btn.addEventListener('click', closePopup)
    );

    // Delay so it doesn’t slap users in the face
    setTimeout(openPopup, 2000);
  });
})();
